module.exports = __webpack_public_path__ + "static/4-b293eb5a3bc7a500594a99494097c950.jpeg";